module.exports = __webpack_public_path__ + "img/3.5df49333.png";